import { GIButton, Modal } from 'app-components';
import React, { useMemo } from 'react';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import { ModalContextType } from '@contexts/modalContext';

import { IResultModal } from '../common/types';
import { MODAL_KEYS } from './modalKeys';

interface IModalProps extends ModalContextType {
    result: IResultModal;
}

const ResultModal = ({ closeModal, result: { isSuccess, isError, message, handleSubmit } }: IModalProps) => {
    const modalTitle = useMemo(() => {
        if (isSuccess) {
            return 'member.enrollment_list.modal.successHeading';
        }
        if (isError) {
            return 'member.enrollment_list.modal.errorHeading';
        }
        return '';
    }, [isSuccess, isError]);

    const handleClose = e => {
        closeModal(MODAL_KEYS.RESULT);
        handleSubmit && handleSubmit();
        e.preventDefault();
    };

    return (
        <Modal id={MODAL_KEYS.OVERRIDE_ENROLLMENT_STATUS} data-testid="result-modal">
            <Modal.Header id="result-modal-header" titleId={modalTitle} onHide={handleClose} />

            <Modal.Body data-testid="modal-body">
                {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
                <h3 data-testid="error-heading"></h3>
                <ConditionalRendering isTrue={Array.isArray(message)}>
                    {Array.isArray(message) &&
                        message.map((msg, index) => (
                            <p key={index} data-testid={`error-message-${index}`}>
                                {msg}
                            </p>
                        ))}
                </ConditionalRendering>
                <ConditionalRendering isTrue={!Array.isArray(message)}>
                    <p data-testid="error-message">{message}</p>
                </ConditionalRendering>
            </Modal.Body>
            <Modal.Controls data-testid="modal-controls">
                <ConditionalRendering isTrue={isSuccess || isError}>
                    <GIButton
                        id="button"
                        onClickHandler={handleClose}
                        variant="secondary"
                        labelId="button.close"
                        data-testid="ok-button"
                    />
                </ConditionalRendering>
            </Modal.Controls>
        </Modal>
    );
};

export default ResultModal;
